import { asset } from './asset';
import Kicker from './Kicker';
import SectionShell from './SectionShell';
import { useTranslation } from 'react-i18next';

function SystemLayersSection() {
  const { t } = useTranslation();
  const layers = [
    {
      number: '01',
      label: t('system.layers.l1_label'),
      title: t('system.layers.l1_title'),
      copy: t('system.layers.l1_copy'),
    },
    {
      number: '02',
      label: t('system.layers.l2_label'),
      title: t('system.layers.l2_title'),
      copy: t('system.layers.l2_copy'),
    },
    {
      number: '03',
      label: t('system.layers.l3_label'),
      title: t('system.layers.l3_title'),
      copy: t('system.layers.l3_copy'),
    },
  ];

  return (
    <SectionShell id="system">
      <div className="grid gap-12 lg:items-start">
        <div>
          <Kicker className="text-black">{t('system.kicker')}</Kicker>
          <h2 className="text-4xl font-black leading-tight sm:text-5xl text-center">{t('system.title')}</h2>
          <p className="mt-6 text-lg leading-8 text-slate-600 text-center">
            {t('system.body')}
          </p>

          <img
            src={asset('image7.png')}
            alt={t('system.image_alt')}
            className="mt-8 w-full max-w-md rounded border border-slate-200 bg-white m-auto"
          />
        </div>

        <div className="grid gap-4">
          {layers.map((layer) => (
            <article key={layer.number} className="grid gap-5 rounded border border-slate-200 bg-white p-6 sm:grid-cols-[80px_1fr]">
              <div className="text-5xl font-light text-emerald-500">{layer.number}</div>
              <div>
                <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-emerald-500">{layer.label}</p>
                <h3 className="mt-2 text-2xl font-black">{layer.title}</h3>
                <p className="mt-3 text-base leading-7 text-slate-600">{layer.copy}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </SectionShell>
  );
}

export default SystemLayersSection;
